import { render, staticRenderFns } from "./HouseMoneyList.vue?vue&type=template&id=2508ac8b&scoped=true&"
import script from "./HouseMoneyList.vue?vue&type=script&lang=js&"
export * from "./HouseMoneyList.vue?vue&type=script&lang=js&"
import style0 from "./HouseMoneyList.vue?vue&type=style&index=0&id=2508ac8b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508ac8b",
  null
  
)

export default component.exports